import {useContext} from 'react';
import {useQuery} from '@tanstack/react-query';
import MemberContext from '../../contexts/MemberContext';
import useProductFilters from '../useProductFilters';
import {sortStringToGraphQLSort} from '../../utils/productQuery';
import RegistryShoppingGraphQL from '../../services/RegistryShoppingGraphQL';
import useCurrentPageCursor from '../useCurrentPageCursor';

export default function useGetProductListProductsBySlug({
  includeAward = true,
  slug,
  skip = false,
} = {}) {
  const {member, isFetchingMember} = useContext(MemberContext);
  const {filter, sort} = useProductFilters();
  const {currentPage} = useCurrentPageCursor();

  const variables = {
    after: currentPage,
    slug,
    filter,
    sort: sortStringToGraphQLSort(sort),
    includeAward,
  };

  return useQuery({
    queryKey: ['productListProducts', member?.id, slug, variables],
    queryFn: () =>
      RegistryShoppingGraphQL.getProductListProductsBySlug(variables),
    enabled: !isFetchingMember && !skip && !!slug,
  });
}
